/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_AdjustInputs */

const en_settings_billing_adjust = /** @type {(inputs: Settings_Billing_AdjustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change plan`)
};

/**
* | output |
* | --- |
* | "Change plan" |
*
* @param {Settings_Billing_AdjustInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_adjust = /** @type {((inputs?: Settings_Billing_AdjustInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_AdjustInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_adjust(inputs)
});
export { settings_billing_adjust as "settings.billing.adjust" }